<div class="flex h-full w-full min-w-0 max-w-[100vw] flex-col bg-gray-50 overflow-hidden sm:max-w-[min(1150px,100vw-1rem)] lg:max-w-[min(1150px,100vw-2rem)]">
  <div
    class="sticky top-0 z-20 flex flex-col gap-4 border-b bg-white px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5 md:px-8 md:py-6 lg:gap-6 xl:gap-8 2xl:gap-10"
  >
    <div class="flex min-w-0 flex-col gap-3 sm:gap-4 lg:flex-row lg:items-center lg:gap-4 xl:gap-6">
      <h2 class="text-xl font-bold tracking-tight text-gray-800 sm:text-2xl">Estructura de Subcampos</h2>
      <span
        class="w-fit rounded-full bg-blue-100 px-3 py-1 text-xs font-bold uppercase tracking-wider text-blue-700"
        >Configuración Interna</span
      >
      <div [formGroup]="form" class="rounded-2xl bg-gray-100 px-3 py-2 sm:px-4">
        <app-toggle-option
          title="Sección Múltiple (Padre)"
          icon="layers"
          iconColor="purple"
          formControlName="multiple"
        ></app-toggle-option>
      </div>
    </div>
    <div class="flex flex-shrink-0 flex-wrap items-center justify-end gap-2 sm:gap-3">
      <button mat-button type="button" (click)="dialogRef.close()">Cancelar</button>
      <button mat-button type="button" class="btn-dialog-soft-primary" (click)="addField()">
        <mat-icon class="mr-2">add_circle</mat-icon>
        Agregar Campo
      </button>
    </div>
  </div>

  <mat-dialog-content class="m-0 flex-1 overflow-y-auto !p-4 sm:!p-6 md:!p-8">
    <form [formGroup]="form" class="w-full">
      <div formArrayName="fields" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 w-full">

        <div *ngFor="let field of fields.controls; let i = index" [formGroupName]="i"
          class="flex flex-col p-6 border border-gray-200 rounded-3xl bg-white shadow-sm hover:shadow-md transition-all">

          <div class="flex justify-between items-center mb-6">
            <span class="px-3 py-1 bg-gray-100 text-gray-400 rounded-full text-[10px] font-bold uppercase tracking-widest">
              Subcampo #{{i + 1}}
            </span>
            <button mat-icon-button color="warn" class="bg-red-50 hover:bg-red-100 rounded-full" (click)="confirmDeleteField(i)">
              <mat-icon style="font-size: 18px;">delete_outline</mat-icon>
            </button>
          </div>

          <mat-form-field appearance="outline" class="w-full mb-1">
            <mat-label>Nombre Campo (DB)</mat-label>
            <input
              matInput
              formControlName="fieldName"
              (input)="ufField.sync($event, field.get('fieldName'))"
              (keydown)="ufField.block($event)"
            />
            <mat-hint>{{ uf.hint }}</mat-hint>
            <mat-error *ngIf="field.get('fieldName').hasError('required')">El nombre es obligatorio.</mat-error>
            <mat-error *ngIf="field.get('fieldName').hasError('pattern')">{{ uf.hint }}</mat-error>
            <mat-error *ngIf="field.get('fieldName').hasError('duplicateName')">
              Este nombre ya está en uso en otro subcampo.
            </mat-error>
          </mat-form-field>

          <div formGroupName="fieldLabel" class="flex flex-col p-4 bg-gray-50 rounded-2xl mb-4 border border-gray-100 gap-2">
            <p class="text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">
              Etiquetas de Interfaz
            </p>
            <mat-form-field class="w-full" appearance="fill">
              <mat-label>BackOffice</mat-label>
              <input matInput formControlName="master" />

              <mat-error *ngIf="field.get('fieldLabel.master')?.touched && field.get('fieldLabel.master')?.hasError('required')">
                La etiqueta BackOffice es obligatoria
              </mat-error>
            </mat-form-field>

            <div class="grid grid-cols-2 gap-2">
              <mat-form-field class="w-full" appearance="fill">
                <mat-label>Reporte</mat-label>
                <input matInput formControlName="report" />

                <mat-error *ngIf="field.get('fieldLabel.report')?.touched && field.get('fieldLabel.report')?.hasError('required')">
                  La etiqueta de reporte es obligatoria
                </mat-error>
              </mat-form-field>
              <mat-form-field class="w-full" appearance="fill">
                <mat-label>Móvil</mat-label>
                <input matInput formControlName="mobile" />

                <mat-error *ngIf="field.get('fieldLabel.mobile')?.touched && field.get('fieldLabel.mobile')?.hasError('required')">
                  La etiqueta móvil es obligatoria
                </mat-error>
              </mat-form-field>

            </div>
          </div>

          <div class="flex items-center gap-2 mb-4">
            <mat-form-field appearance="outline" class="flex-grow">
              <mat-label>Tipo</mat-label>
              <mat-select formControlName="fieldType">
                <mat-option *ngFor="let opt of fieldTypeOptions" [value]="opt.value">{{opt.label}}</mat-option>
              </mat-select>
            </mat-form-field>

            <button mat-mini-fab color="primary" type="button"
              *ngIf="['select', 'multiselect', 'attachment'].includes(field.get('fieldType').value)"
              (click)="openConfigModal(field)" matTooltip="Configurar detalles">
              <mat-icon>settings</mat-icon>
            </button>
          </div>

          <hr class="mb-4 opacity-50">

          <div class="grid grid-cols-2 gap-2 mb-2">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Grupo</mat-label>
              <mat-select formControlName="group">
                <mat-option *ngFor="let opt of userFieldGroupOptions" [value]="opt.value">
                  {{ opt.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Pos. Grupo</mat-label>
              <input matInput type="number" formControlName="groupPosition">
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-2 mb-2">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Icono</mat-label>
              <input matInput formControlName="icon">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Color Icono</mat-label>
              <input matInput formControlName="iconColor">
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-2 mb-2">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Posición</mat-label>
              <input matInput type="number" formControlName="position">
              <mat-error *ngIf="field.get('position').hasError('duplicatePosition')">
                Posición ocupada. (Sugerencia: {{ field.get('position').errors?.lastOccupied + 1 }})
              </mat-error>
            </mat-form-field>
          </div>

          <div class="w-full mb-1">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Valor Default</mat-label>
              <input matInput formControlName="defaultValue">
            </mat-form-field>
          </div>

          <hr class="mb-4 opacity-50">

          <div class="w-full mb-1">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Máx. Char</mat-label>
              <input matInput type="number" formControlName="maxLength" />
            </mat-form-field>
          </div>

          <div class="w-full mb-1">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Mín. Char</mat-label>
              <input matInput type="number" formControlName="minLength" />
              <mat-error *ngIf="field.get('minLength')?.hasError('minGreaterThanMax')">
                El mínimo no puede ser mayor que el máximo.
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="field.get('fieldType')?.value === 'text'" class="w-full mb-1">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Conversión de Texto</mat-label>
              <mat-select formControlName="caseConversion">
                <mat-option value="NONE">Ninguno</mat-option>
                <mat-option value="UPPER">Mayúsculas</mat-option>
                <mat-option value="LOWER">Minúsculas</mat-option>
                <mat-option value="TITLE">Capitalizar palabras</mat-option>
                <mat-option value="SENTENCE">Capitalizar primera</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="field.get('fieldType')?.value === 'text'" class="w-full mb-1">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Máscara de Texto</mat-label>
              <input matInput formControlName="mask" placeholder="Ej. (000) 000-000" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-2 mb-2">
            <mat-form-field appearance="outline"><mat-label>Campo Padre</mat-label><input matInput
                formControlName="parentFieldName" /></mat-form-field>
            <mat-form-field appearance="outline"><mat-label>Schema</mat-label><input matInput
                formControlName="schemaMaster" /></mat-form-field>
          </div>

          <div class="space-y-2 bg-gray-50 p-4 rounded-2xl border border-dashed border-gray-300">
            <app-toggle-option title="Visible" icon="visibility" iconColor="blue" formControlName="isVisible">
            </app-toggle-option>
            <br>
            <app-toggle-option title="Requerido" icon="error_outline" iconColor="orange" formControlName="isRequired">
            </app-toggle-option>
            <br>
            <app-toggle-option title="Mandatorio" icon="gavel" iconColor="red" formControlName="isTypeMandatory">
            </app-toggle-option>
            <ng-container *ngIf="field.get('fieldType')?.value === 'text'">
              <br>
              <app-toggle-option title="Eliminar espacios" icon="content_cut" iconColor="green" formControlName="trimSpaces">
              </app-toggle-option>
            </ng-container>
          </div>

        </div>
      </div>
    </form>
  </mat-dialog-content>

  <div class="flex justify-end items-center px-8 py-6 border-t bg-white sticky bottom-0 z-20 shadow-lg">
    <button mat-flat-button color="primary" class="px-12 py-3 rounded-xl text-lg font-bold shadow-sm" (click)="save()"
      [disabled]="form.invalid">
      Confirmar Estructura
    </button>
  </div>
</div>